function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import isEqual from 'lodash/isEqual';
import mutuallyExclusiveProperties from '@signal/prop-types/mutuallyExclusiveProperties';
import renderIf from '@signal/utils/renderIf';
/**
 * Condition that controls when a route should be rendered, and instructs the
 * `ConditionalRoute` component what to do when it should not be rendered.
 * @typedef {Object} RouteCondition
 * @property {Boolean} condition - condition when the route should render
 * @property {String} [redirectTo] - react route to redirect to when condition is `false`
 * @property {Function} [onFailure] - handler to call when condition is `false`
 * @global
 */

var RouteCondition = PropTypes.objectOf(mutuallyExclusiveProperties({
  condition: PropTypes.bool.isRequired,
  redirectTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onFailure: PropTypes.func
}, ['redirectTo', 'onFailure'], // these are mutually exclusive
true // one of them is required
));
export var ConditionalRoute = /*#__PURE__*/function (_React$Component) {
  _inherits(ConditionalRoute, _React$Component);

  var _super = _createSuper(ConditionalRoute);

  function ConditionalRoute() {
    var _this;

    _classCallCheck(this, ConditionalRoute);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      failedCondition: null,
      lastConditions: null
    });

    return _this;
  }

  _createClass(ConditionalRoute, [{
    key: "shouldComponentUpdate",
    value:
    /**
     * Some of the props the react router related props that are passed in
     * are occasionally are referentially different but are equal in value.
     * computedMatch is one example that is currently known of.
     */
    function shouldComponentUpdate(nextProps) {
      return !isEqual(this.props, nextProps);
    } // eslint-disable-next-line no-unused-vars

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var failedCondition = this.state.failedCondition;

      if (failedCondition && failedCondition !== prevState.failedCondition && failedCondition.onFailure) {
        // if there is a new failed condition with an `onFailure` handler, call
        // the handler
        failedCondition.onFailure();
      }
    } // only render a redirect component if the failed condition has a `redirectTo`
    // property specified

  }, {
    key: "redirectComponent",
    get: function get() {
      var failedCondition = this.state.failedCondition;

      if (failedCondition && failedCondition.redirectTo) {
        return function () {
          return /*#__PURE__*/React.createElement(Redirect, {
            to: failedCondition.redirectTo
          });
        };
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          C = _this$props.component,
          cProps = _this$props.props,
          render = _this$props.render,
          rest = _objectWithoutProperties(_this$props, ["component", "props", "render"]);

      var failedCondition = this.state.failedCondition;
      return renderIf(!failedCondition, render(this.props, function () {
        return /*#__PURE__*/React.createElement(Route, Object.assign({}, rest, {
          render: function render(props) {
            return /*#__PURE__*/React.createElement(C, Object.assign({}, props, cProps, rest));
          }
        }));
      }), this.redirectComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var conditions = _ref.conditions;

      if (conditions !== state.lastConditions) {
        var newState = {
          lastConditions: conditions
        };
        var failedCondition = conditions.find(function (_ref2) {
          var condition = _ref2.condition;
          return !condition;
        });

        if (!isEqual(failedCondition, state.failedCondition)) {
          newState = _objectSpread(_objectSpread({}, newState), {}, {
            failedCondition: failedCondition
          });
        }

        return newState;
      }

      return null;
    }
  }]);

  return ConditionalRoute;
}(React.Component);

_defineProperty(ConditionalRoute, "propTypes", {
  conditions: PropTypes.arrayOf(RouteCondition)
});

_defineProperty(ConditionalRoute, "defaultProps", {
  conditions: [],
  // eslint-disable-next-line no-unused-vars
  render: function render(props, component) {
    return component;
  }
});

export default ConditionalRoute;